<div class="background">
  <div class="text" data-qa="welcome-text">
        <span>
        Das TNB-Portal UFLA ist eine webbasierte Anwendung für Netzbetreiber.
        Es dient dem Informations- und Datenaustausch zum automatischen unterfrequenzabhängigen Lastabwurf (UFLA) nach den
        Vorgaben der VDE-AR-N 4142.
        </span>
    @if ((displayLoginError$ | async) === false) {
      <button matButton="filled"
              class="button-white login"
              (click)="login()" data-qa="login-button">
        <mat-icon>launch</mat-icon>
        <span>Zum Login</span>
      </button>
    } @else {
      <span data-qa="login-error-text">
        Ein Zugriff auf die Anwendung ist nicht möglich.
          Wenn Sie weiterhin Probleme haben, auf die Anwendung zuzugreifen, wenden Sie sich bitte an den Support.
      </span>
      <button matButton="filled" class="button-white login"
              (click)="logout()" data-qa="logout-button">
        <mat-icon>launch</mat-icon>
        <span>Abmelden</span>
      </button>
    }
  </div>
</div>
